import {
  blogPostsPart1,
  postImages,
  categoryFallbackImages,
} from './blogPosts'
import { blogPostsPart2 } from './blogPostsPart2'
import type { BlogPost, BlogCategory } from './blogPosts'

export const blogPosts: BlogPost[] = [...blogPostsPart1, ...blogPostsPart2]

export const getBlogPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find((post) => post.slug === slug)
}

export const getBlogPostsByCategory = (category: BlogCategory): BlogPost[] => {
  return blogPosts.filter((post) => post.category === category)
}

export const getBlogCategories = (): BlogCategory[] => {
  return Array.from(new Set(blogPosts.map((post) => post.category)))
}

// Elk artikel heeft een eigen beeld. Ontbreekt dat, dan valt het terug op
// het beeld van het onderwerp.
export const getBlogImage = (post: BlogPost): string =>
  postImages[post.slug] ?? categoryFallbackImages[post.category]

export { postImages, categoryFallbackImages }
export type { BlogPost, BlogCategory }
